import CloseIcon from '@mui/icons-material/Close';
import MinimizeIcon from '@mui/icons-material/Remove';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import { Avatar, Box, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { getPanelInitials } from './fidesChatPanelUtils';

interface FidesChatPanelHeaderProps {
  contactName: string;
  contactEmail: string;
  isTranscriptMode: boolean;
  hasTeamReply: boolean;
  openConversationId: string | null;
  onOpenDraftNotes: () => void;
  onMinimize: () => void;
  onClose: () => void;
}

const FidesChatPanelHeader: React.FC<FidesChatPanelHeaderProps> = ({
  contactName,
  contactEmail,
  isTranscriptMode,
  hasTeamReply,
  openConversationId,
  onOpenDraftNotes,
  onMinimize,
  onClose,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      px: 2,
      py: 1.5,
      backgroundColor: Palette.default.buttonBg,
      color: '#fff',
    }}
  >
    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.18)', width: 40, height: 40 }}>
      {getPanelInitials(contactName)}
    </Avatar>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant="subtitle1" fontWeight={600} noWrap>
        {contactName}
      </Typography>
      {isTranscriptMode ? (
        <Typography variant="body2" sx={{ opacity: 0.85 }} noWrap>
          Chat transcript
        </Typography>
      ) : contactEmail ? (
        <Typography variant="body2" sx={{ opacity: 0.85 }} noWrap>
          {contactEmail}
        </Typography>
      ) : null}
    </Box>
    {hasTeamReply && (
      <Tooltip title="Draft notes from chat (optional)">
        <span>
          <IconButton
            onClick={onOpenDraftNotes}
            disabled={!openConversationId}
            sx={{ color: '#fff' }}
            aria-label="Draft notes from chat"
          >
            <NoteAddOutlinedIcon />
          </IconButton>
        </span>
      </Tooltip>
    )}
    <IconButton onClick={onMinimize} sx={{ color: '#fff' }} aria-label="Minimize chat panel">
      <MinimizeIcon />
    </IconButton>
    <IconButton onClick={onClose} sx={{ color: '#fff' }} aria-label="Close chat panel">
      <CloseIcon />
    </IconButton>
  </Box>
);

export default FidesChatPanelHeader;
